<template>
    <div class="w-full">
        <div class="p-4">
            <ul>
                <li v-for="answer in question.options.answers">
                    <CorrectIncorrectIcon :is-correct="true" />
                    {{ answer.text }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionShortAnswerViewOnly',
    components: {
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
